<template>
    <search-multiselect
        v-model="selectedCleaners"
        :options="cleanerOptions"
        :variant="variant"
        placeholder="Cleaners"
        controlValue="Cleaners"
        :icon="['fas', 'hand-sparkles']"
        @show="onControlShow"
        @hide="onControlHide"
        @shown="onControlShown"
        @hidden="onControlHidden"
    ></search-multiselect>
</template>

<script>
import SearchMultiselect from '../search-multiselect/search-multiselect.vue';

export default {
    name: 'CleanersSearchMultiselect',
    components: { SearchMultiselect },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        initialValue: {
            type: Array,
            default: null,
        },
        cleaners: {
            type: Array,
            default: () => [],
        },
        variant: {
            type: String,
            default: '',
        },
        error: {
            type: String,
            default: null,
        },
    },
    computed: {
        cleanerOptions() {
            const initialCleanerIDs = new Set(
                (this.initialValue || []).map((cleaner) => cleaner.id)
            );
            const disabledCleanerIDs = new Set(
                this.cleaners
                    .filter((cleaner) => cleaner.disabled)
                    .map((cleaner) => cleaner.id)
            );
            return this.cleaners
                .filter((cleaner) => {
                    return (
                        !disabledCleanerIDs.has(cleaner.id) ||
                        initialCleanerIDs.has(cleaner.id)
                    );
                })
                .map((cleaner) => ({
                    value: cleaner.id,
                    text: cleaner.full_name,
                }));
        },
        selectedCleaners: {
            get: function () {
                return this.value;
            },
            set: function (selectedCleaners) {
                this.$emit('input', selectedCleaners);
            },
        },
    },
    methods: {
        onControlShow(e) {
            this.$emit('show', e);
        },
        onControlHide(e) {
            this.$emit('hide', e);
        },
        onControlShown() {
            this.$emit('shown');
        },
        onControlHidden() {
            this.searchValue = '';
            this.$emit('hidden');
        },
    },
};
</script>
